export default __webpack_public_path__ + "static/cover-16acc0bd3e87b60f96714f5e3570c95a.png";